<template>
 <div
        v-show="data.length > 0"
        :elevation="$vuetify.breakpoint.smAndDown ? 0 : 2"
    >
<v-expansion-panels>
    <v-expansion-panel class="mb-5">
        <v-expansion-panel-header v-if="!$vuetify.breakpoint.smAndDown" class="title">{{
            name
        }} 
        </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-divider v-if="!$vuetify.breakpoint.smAndDown" />
        <div class="d-flex justify-end">
            <v-switch class="ml-1" label="Des" v-model="sort" dense hide-details @change="sortData"></v-switch>
        </div>
        <v-card-text
            :style="
                ` ${
                    !$vuetify.breakpoint.smAndDown ? 'max-height:200px;' : ''
                }overflow: auto;`
            "
            class="pa-0"
        >
            <v-list>
                <v-list-item-group
                    v-model="multipleValues"
                    :multiple="isMultiple"
                    active-class=""
                >
                    <template v-for="(item, i) in data">
                        <v-list-item :key="i" :value="item.key">
                            <template v-slot:default="{ active }">
                                <v-list-item-action>
                                    <v-checkbox
                                        :input-value="active"
                                    ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        `${item.key} (${kFormatter(
                                            item.doc_count
                                        )})`
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </template>
                </v-list-item-group>
            </v-list>
        </v-card-text>
        </v-expansion-panel-content>
    
    </v-expansion-panel>
</v-expansion-panels>
</div>
</template>
<script>
export default {
    name: 'FacetCard',
    props: {
        name: {
            type: String,
            required: true
        },
        isMultiple: {
            type: Boolean,
            required: true,
            default: true
        },
        data: {
            type: Array,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        },
        selectedFacets: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            multipleValues: [],
            sort:false
        }
    },
    watch: {
        multipleValues(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('change', this.multipleValues)
            }
        }
    },
    mounted() {
        this.multipleValues = this.data
            .filter((item) =>
                this.selectedFacets.find(
                    (sf) => sf.label.split(':')[1].trim() === item.key
                )
            )
            .map((item) => item.key)
    },
    methods:{
        sortData(){
            this.$emit('sortData',this.name,this.sort)
        }
    }
}
</script>
<style scoped>
.v-list-item{
    min-height:0 !important;
}
.v-list-item__content{
    padding: 0;
}
.v-list-item__action{
    margin: 0;
}
.v-input--selection-controls{
    margin-top:0;
    margin-bottom: 10px;
}
.v-expansion-panel-header{
    padding: 0px 10px !important;
}
.v-expansion-panel-content>>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
  padding-right: 10px !important;
  padding-bottom:10px !important;
}
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 10px !important;
}
</style>
